export const getFormData = (data: any): FormData => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    const items = Array.isArray(value) ? value : [value];
    items.forEach((item) => {
      if (item && typeof item.blob !== 'undefined') {
        formData.append(key, item.blob, item.fileName);
      } else {
        formData.append(key, item);
      }
    });
  });
  return formData;
};
